import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import PhotoIcon from "@mui/icons-material/Photo";
import TableViewIcon from "@mui/icons-material/TableView";
import DownloadIcon from "@mui/icons-material/Download";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { MainButton } from "../SXStyle";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#484d50",
    color: "#fffcfc",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));


// Estilo para el footer sticky:
const StickyFooterCell = styled(TableCell)({
  position: 'sticky',
  bottom: 0,
  zIndex: 2,
  background: '#fff', // Asegura contraste con el contenido
});

const exportToExcel = (jsonData, fileName) => {
  const worksheet = XLSX.utils.json_to_sheet(jsonData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

const exportToPNG = async () => {
  const element = document.getElementById("tabla-datos");
  const canvas = await html2canvas(element);
  const link = document.createElement("a");
  link.download = "tabla.png";
  link.href = canvas.toDataURL("image/png");
  link.click();
};

export default function TableComponent({ cifrasSeleccionadas }) {


  
  const [resumenPonderados, setResumenPonderados] = useState([]);

  useEffect(() => {
    if (cifrasSeleccionadas?.length > 0) {
      setResumenPonderados(resumenPonderadosCalculados(cifrasSeleccionadas));
    }
  }, [cifrasSeleccionadas]);

  //calcula los ponderados finales (resumen)
  function resumenPonderadosCalculados(agrupado) {
    let totalToneladas = 0;
    let sumAuEq_Gr_t = 0;
    let sumAu_Gr_t = 0;
    let sumCu_pct = 0;
    let sumFe_pct = 0;

    agrupado.forEach((item) => {
      const toneladas = Number(item.sumTonelada) || 0;
      const auEq_Gr_t = Number(item.AuEq_Gr_t) || 0;
      totalToneladas += toneladas;

      sumAu_Gr_t += toneladas * (Number(item.Au_Gr_t) || 0); //='Au * tons'/Toneladas
      sumCu_pct += toneladas * (Number(item.Cu_pct) || 0); //='Cu% * tons '/Toneladas
      sumAuEq_Gr_t += toneladas * auEq_Gr_t; //='AuEq * tons'/Toneladas
      sumFe_pct += toneladas * (Number(item.Fe_pct) || 0); //='Fe * tons'/Toneladas
    });

    const dividir = (total) =>
      totalToneladas ? (total / totalToneladas).toFixed(2) : "0.00";
    const dividirSiError = (total) =>
      totalToneladas > 0 && total > 0 ? (total / 31.1035).toFixed(2) : "0.00";

    let result = {
      Toneladas: totalToneladas.toFixed(2),
      AuEq_Gr_t: dividir(sumAuEq_Gr_t),
      Au_Gr_t: dividir(sumAu_Gr_t),
      Cu_pct: dividir(sumCu_pct),
      Fe_pct: dividir(sumFe_pct),
    };

    return result;
  }

  return (
    <>
      <div id="tabla-datos">
        <TableContainer
          component={Paper}
        >
          <Table aria-label="customized table" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>Nivel</StyledTableCell>
                <StyledTableCell align="right">Toneladas</StyledTableCell>
                <StyledTableCell align="right">AuEq Gr/t</StyledTableCell>
                <StyledTableCell align="right">Au Gr/t</StyledTableCell>
                <StyledTableCell align="right">Cu%</StyledTableCell>
                <StyledTableCell align="right">Fe%</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {cifrasSeleccionadas.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell component="th" scope="row">
                    {row.numero + " - " + row.nivel}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.sumTonelada}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.AuEq_Gr_t}
                  </StyledTableCell>
                  <StyledTableCell align="right">{row.Au_Gr_t}</StyledTableCell>
                  <StyledTableCell align="right">{row.Cu_pct}</StyledTableCell>
                  <StyledTableCell align="right">{row.Fe_pct}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <StickyFooterCell
                  sx={{
                    fontWeight: 600,
                    color: "#fffcfc",
                    background: "#484d50",
                  }}
                >
                  Total General
                </StickyFooterCell>
                <StickyFooterCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: "#fffcfc",
                    background: "#484d50",
                  }}
                >
                  {resumenPonderados.Toneladas}
                </StickyFooterCell>
                <StickyFooterCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: "#fffcfc",
                    background: "#484d50",
                  }}
                >
                  {resumenPonderados.AuEq_Gr_t}
                </StickyFooterCell>
                <StickyFooterCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: "#fffcfc",
                    background: "#484d50",
                  }}
                >
                  {resumenPonderados.Au_Gr_t}
                </StickyFooterCell>
              
                <StickyFooterCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: "#fffcfc",
                    background: "#484d50",
                  }}
                >
                  {resumenPonderados.Cu_pct}
                </StickyFooterCell>
               
                <StickyFooterCell
                  align="right"
                  sx={{
                    fontWeight: 600,
                    color: "#fffcfc",
                    background: "#484d50",
                  }}
                >
                  {resumenPonderados.Fe_pct}
                </StickyFooterCell>
                
            
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>

      <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
        <Button
          onClick={() => exportToExcel(cifrasSeleccionadas, "dashboard")}
          variant="contained"
          sx={{ ...MainButton, width: "120px" }}
          endIcon={<TableViewIcon />}
        >
          Excel
        </Button>
        <Button
          onClick={exportToPNG}
          variant="contained"
          sx={{ ...MainButton, width: "120px" }}
          endIcon={<PhotoIcon />}
        >
          Imagen
        </Button>
      </div>
    </>
  );
}
